import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import getComponentWithTheme from '../../themeProvider';
import STRINGS from '../constants';
import RegistrationPageContext from './RegistrationPageContext';

const RegistrationPage = (props) => {
	const {
		siteDetails, reCaptchaKey, showCaptcha, registrationCustomFields, csrfToken, googleUrl,
	} = props;

	const [tabs, setTabs] = useState({});
	const [selectedTab, setSelectedTab] = useState('');

	useEffect(() => {
		const newTabs = {};
		if (siteDetails.registrantType === '0' || siteDetails.registrantType === '2') {
			newTabs.individualTab = {
				label: STRINGS.registrationPage.individualTabTitle,
				id: 'individualTab',
			};
		}
		if (siteDetails.registrantType === '1' || siteDetails.registrantType === '2') {
			newTabs.organizationTab = {
				label: STRINGS.registrationPage.organizationTabTitle,
				id: 'organizationTab',
			};
		}
		newTabs[Object.keys(newTabs)[0]].active = true;
		setSelectedTab(Object.keys(newTabs)[0]);
		setTabs(newTabs);
	}, []);

	const handleTabChange = (event) => {
		setSelectedTab(event.currentTarget.value);
		setTabs({
			...tabs,
			[selectedTab]: {
				...tabs[selectedTab],
				active: false,
			},
			[event.currentTarget.value]: {
				...tabs[event.currentTarget.value],
				active: true,
			},
		});
	};

	return (
		getComponentWithTheme(
			<RegistrationPageContext
				tabs={tabs}
				handleTabChange={handleTabChange}
				selectedTab={selectedTab}
				siteDetails={siteDetails}
				reCaptchaKey={reCaptchaKey}
				showCaptcha={showCaptcha}
				registrationCustomFields={registrationCustomFields}
				csrfToken={csrfToken}
				googleUrl={googleUrl}
			/>,
			window?.LOCALE?.theme,
		)
	);
};

RegistrationPage.propTypes = {
	siteDetails: PropTypes.object.isRequired,
	reCaptchaKey: PropTypes.string.isRequired,
	registrationCustomFields: PropTypes.array,
	showCaptcha: PropTypes.bool,
	googleUrl: PropTypes.string.isRequired,
};
RegistrationPage.defaultProps = { showCaptcha: true, registrationCustomFields: [] };

export default RegistrationPage;
